import { useMutation, useQueryClient } from '@tanstack/react-query'
import { insightsRepo } from '@/lib/repositories'
import type { UpdateInsightData } from '@/lib/repositories/interfaces/IInsightsRepository'
import { analytics } from '@/lib/services/analytics'
import { AnalyticsEvents } from '@/lib/services/analytics-events'

export function useUpdateInsight() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateInsightData }) =>
      insightsRepo.updateInsight(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['insights'] })
      analytics.capture(AnalyticsEvents.INSIGHT_UPDATED)
    },
  })
}
